module.exports = "/packs/images/products/blush-gold-device-staged-mobile-227f03e07337d233835f4eb5bae340d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/products/blush-gold-device-staged-mobile.jpg
// module id = 1799
// module chunks = 0